import {
  Css_HeadingH3_tw,
  Css_Text_16_24_To_13_18_5_tw,
  Css_Text_20_30_To_16_24_tw,
} from '@dreamstack/feature-components/src/layout/Texts'
import { clsxMerge } from '@dreamstack/util'
import type { FunctionComponent } from 'react'
import React from 'react'

// const DefinitionList = tw.dl`${(props) => {
//   return props.big ? 'text-lg' : 'text-base'
// }} font-montserrat`

const DefinitionList = ({
  big,
  className,
  ...rest
}: React.HTMLAttributes<HTMLDListElement> & { big?: boolean }) => (
  <dl
    {...rest}
    className={clsxMerge(
      big ? 'text-lg' : 'text-base',
      'font-montserrat',
      className
    )}
  />
)

// const Description = tw.dd`${(props) => {
//   return props.big ? 'text-lg font-semibold' : 'font-semibold'
// }}`

const Description = ({
  big,
  className,
  ...rest
}: React.HTMLAttributes<HTMLElement> & { big?: boolean }) => (
  <dd
    {...rest}
    className={clsxMerge(
      big ? Css_Text_20_30_To_16_24_tw : Css_Text_16_24_To_13_18_5_tw,
      className
    )}
  />
)

const DefinitionTerm = ({
  big,
  className,
  ...rest
}: React.HTMLAttributes<HTMLElement> & { big?: boolean }) => (
  <dt
    {...rest}
    className={clsxMerge(
      'font-semibold',
      big ? Css_HeadingH3_tw : Css_Text_20_30_To_16_24_tw,
      className
    )}
  />
)

export const SimpleDefinitionList: FunctionComponent<
  React.PropsWithChildren<{
    dt: string | React.ReactNode
    dd: string | React.ReactNode
    className?: string
    big?: boolean
  }>
> = ({ dt, dd, className, big }) => {
  return (
    <DefinitionList big={big} className={className}>
      <DefinitionTerm big={big}>{dt}</DefinitionTerm>
      <Description big={big}>{dd}</Description>
    </DefinitionList>
  )
}
